import { Dispatch, SetStateAction } from 'react';

export default function OrderController({
  order,
  setOrder,
}: {
  order: string;
  setOrder: Dispatch<SetStateAction<'asc' | 'desc'>>;
}) {
  function handleOrderChange() {
    if (order == 'asc') {
      setOrder('desc');
    } else {
      setOrder('asc');
    }
  }

  return (
    <img
      src={order == 'asc' ? 'svg/az.svg' : 'svg/za.svg'}
      onClick={handleOrderChange}
      className="selector-order"
      data-qa-element-id="order_selector"
    />
  );
}
